import React, {Component} from 'react';
import {Avatar} from 'antd';
import {createHistory} from 'react-router'
import './style.scss';

export default class MiniHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFocus: false,
      value: ''
    }
  }

  componentDidUpdate() {

  }

  inputOnFocus = () => {
    this.setState({
      searchFocus: true
    })
  }

  inputOnBlur = () => {
    this.setState({
      searchFocus: false
    })
  }

  onSearchChange = (e) => {
    console.log(e)
  }

  render() {
    const {searchFocus} = this.state
    const {inputOnFocus, inputOnBlur, onSearchChange} = this
    return (
      <div className="topbar">
        <div className="main">
          <h1><a href="/">新小说吧</a></h1>
        </div>
      </div>
    )
  }
}
